<template>
  <div id="app">
    <EventEnd v-if="activityStatusReady && isEventEnded" />
    <router-view v-else-if="activityStatusReady" />
    <div v-else class="activity-status-message">
      {{ activityStatusError ? '目前無法取得活動狀態，請稍後重新整理頁面。' : '活動狀態確認中…' }}
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import EventEnd from './views/EventEnd.vue'

const MAX_TIMEOUT = 2147483647
const RETRY_INTERVAL = 30000

export default {
  name: 'App',
  components: {
    EventEnd
  },
  data() {
    return {
      activityStatusReady: false,
      activityStatusError: false,
      isEventEnded: false,
      activityStatusTimer: null
    }
  },
  created() {
    this.loadActivityStatus()
  },
  beforeDestroy() {
    clearTimeout(this.activityStatusTimer)
  },
  methods: {
    async loadActivityStatus() {
      clearTimeout(this.activityStatusTimer)

      try {
        const response = await axios.post('https://taiwanngo.tw/Home/Survey2026Status')
        const result = response.data

        if (!result || !result.ok) {
          throw new Error('Invalid activity status response')
        }

        this.isEventEnded = Boolean(result.isEnded)
        this.activityStatusReady = true
        this.activityStatusError = false

        if (!this.isEventEnded) {
          const remaining = Number(result.millisecondsUntilEnd)
          const delay = Number.isFinite(remaining)
            ? Math.max(1000, Math.min(remaining + 1000, MAX_TIMEOUT))
            : RETRY_INTERVAL
          this.activityStatusTimer = setTimeout(this.loadActivityStatus, delay)
        }
      } catch (error) {
        if (!this.activityStatusReady) {
          this.activityStatusError = true
        }
        this.activityStatusTimer = setTimeout(this.loadActivityStatus, RETRY_INTERVAL)
      }
    }
  }
}
</script>

<style>
</style>
